'use strict';

const _ = require('underscore');
const Base = require('components/Platform/PlatformCardExperience/Steps/BaseAnimation/BaseAnimation');
const Constants = require('constants/Constants');

require('./Verification.less');

const Selectors = {
    el: '.PlatformCardExperienceVerificationStep',
    items: '.PlatformCardExperienceVerificationStep-iconWrapper',
    code: '.PlatformCardExperienceVerificationStep-codeImg img',
    svgItem: '.PlatformCardExperienceIconWrapper-iconImage'
};

const BindFunctions = [
    'progressAnimation',
    'setActiveItem',
    'progressMove',
    'setPaths'
];

const cpAnimation = [-5, -45, -75, -77];
const cpPathsAnimation = [40, 30, 20, 2];
const coeff = 0.15;

module.exports = Base.extend({

    el: Selectors.el,

    initialize: function (options = {}) {
        Base.prototype.initialize.call(this, options);
        _.bindAll(this, BindFunctions);

        this.$items = this.$(Selectors.items);
        this.countItems = this.$items.length;
        this.$code = this.$(Selectors.code);

        this.$svgItems = this.$(Selectors.svgItem);

        this.setPaths();

        app.vent.on('platform-verification-progress', this.progressAnimation);
    },

    progressAnimation: function (params) {
        params = params || {};
        const progress = params.progress || 0;
        const activeIcon = Math.floor(progress / (1 / this.countItems + coeff));

        this.progressMove(activeIcon, progress);

        if (this.activeIcon === activeIcon) {
            return;
        }

        this.activeIcon = activeIcon;
        this.setActiveItem(activeIcon);
    },

    setActiveItem: function (index) {
        const currentItem = $(this.$items[index]);
        const nextItem = $(this.$items[index + 1]);

        if (currentItem) {
            currentItem.addClass(Constants.cssClasses.isActive);
        }

        if (nextItem) {
            nextItem.removeClass(Constants.cssClasses.isActive);
        }
    },

    progressMove: function (index, progress) {
        const curCp = cpAnimation[index];
        const nextCp = cpAnimation[index + 1] || curCp;
        const percent = (1 / this.countItems + coeff);
        const curPercent = percent * index;

        const curPathProgress = cpPathsAnimation[index] * ((progress - curPercent) / percent);
        const curProgress =
            Math.max(
                Math.min(curCp - curPathProgress, curCp),
                nextCp
            );

        this.$code.css('transform', 'translate3d(0, ' + curProgress + '%, 0)');
    },

    setPaths: function () {
        this.$svgItems.each((id, svg) => {
            const $svg = $(svg);

            $svg.find('path').each((i, path) => {
                const lenPath = path.getTotalLength();
                const $path = $(path);

                $path.css({
                    'stroke-dasharray': lenPath,
                    'stroke-dashoffset': lenPath
                });
            });
        });
    }
});
